import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getMarkNamesOld(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/catalogSeo/getMarkNames`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMarkNames(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/catalogSeo/getMarkNamesNew`,
      reset,
    );
  },
});
